import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import buildNavLinksFromBackendTabs from "../navLinks/Navlinks";
import "./Dashboard.css";
import isDesktop from "../isDesktop";
import Sidebar from "../sidenav/Sidenav";
import { ReactComponent as UserIcon } from "../assets/icons/UserIcon.svg";
import { ReactComponent as Hemberger } from "../assets/icons/Hemberger.svg";
import { registerServiceWorker } from "../war-report/serviceWorkerUtils";
import roleService from "../roles/roleService";
import {
  getStoredBackendTabs,
  getStoredTabIds,
  isAdminRole,
} from "../utils/access";
import { useLocalStorage } from "@uidotdev/usehooks";
const publicVapidKey = process.env.REACT_APP_PUBLIC_VAPID_KEY;

const Dashboard = () => {
  const navigate = useNavigate();
  const [token] = useLocalStorage("token", null);
  const userRole = localStorage.getItem("userRole");
  const canSeeAllTabs = isAdminRole(userRole);
  const [allowedTabIds, setAllowedTabIds] = useState(getStoredTabIds);
  const [backendTabs, setBackendTabs] = useState(getStoredBackendTabs);
  const getTabKey = (tab) => tab.route || tab.title;

  const handleNavigation = (route) => {
    navigate(route);
  };

  const filterAllowedTabs = (tabs) => {
    if (canSeeAllTabs) return tabs;
    const allowedTabIdSet = new Set(allowedTabIds.map((tabId) => String(tabId)));
    return tabs.filter((tab) => allowedTabIdSet.has(String(tab.id)));
  };

  const navLinks = buildNavLinksFromBackendTabs(backendTabs);

  const adminSection = navLinks.find((link) => link.tag === "Admin");
  const adminTabs = adminSection ? filterAllowedTabs(adminSection.tabs) : [];

  const leadsSection = navLinks.find(
    (link) => link.tag === "Lead Management System"
  );
  const leadTabs = leadsSection ? filterAllowedTabs(leadsSection.tabs) : [];

  const ContentSection = navLinks.find(
    (link) => link.tag === "Content Management System"
  );
  const contentTabs = ContentSection ? filterAllowedTabs(ContentSection.tabs) : [];

  const analyticsSection = navLinks.find((link) => link.tag === "Analytics");
  const analyticsTabs = analyticsSection ? filterAllowedTabs(analyticsSection.tabs) : [];

  const isDesktopDevice = isDesktop();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  useEffect(() => {
    registerServiceWorker(() => {}, publicVapidKey);
  }, []);

  useEffect(() => {
    let isMounted = true;

    const fetchRoleAccess = async () => {
      if (!token || !userRole) return;

      try {
        const tabs = await roleService.getTabs(token);
        const roleAccess = canSeeAllTabs
          ? null
          : await roleService.getRoleAccess(token, userRole);
        if (!isMounted) return;

        setBackendTabs(tabs);
        localStorage.setItem("backend_tabs", JSON.stringify(tabs));
        if (roleAccess) {
          setAllowedTabIds(roleAccess.tabIds);
          localStorage.setItem("tab_id", JSON.stringify(roleAccess.tabIds));
        } else {
          setAllowedTabIds([]);
        }
      } catch (error) {
        console.error("Failed to fetch employee role access:", error);
      }
    };

    fetchRoleAccess();

    return () => {
      isMounted = false;
    };
  }, [token, userRole, canSeeAllTabs]);

  return (
    <>
      {!isDesktopDevice && (
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              margin: "0.5rem 0.75rem 1.25rem 0.75rem",
            }}
          >
            <div
              onClick={() => setIsSidebarOpen(!isSidebarOpen)}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                width: "36px",
                height: "36px",
                borderRadius: "18px",
                background: "#EAF1F7",
              }}
            >
              <Hemberger />
            </div>
            <Link to="/profile">
              <UserIcon />
            </Link>
          </div>
          <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
        </>
      )}
      <div
        className="container-fluid"
        style={{ marginTop: isDesktopDevice && "6rem" }}
      >
        <div className="content-wrapper">
          <div className="d-flex">
            <div className="page-title">Dashboard</div>
          </div>

          {adminTabs.length > 0 && (
            <>
              <div className="subtitle">Admin</div>
              <div className="dashboard-card-container">
                {adminTabs.map((tab) => (
                  <div key={getTabKey(tab)}>
                    <div
                      onClick={() => handleNavigation(tab.route)}
                      className="dashboard-card"
                    >
                      <div className="card-title">{tab.title}</div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

          {leadTabs.length > 0 && (
            <>
              <div className="subtitle">Lead Management System</div>
              <div className="dashboard-card-container">
                {leadTabs.map((tab) => (
                  <div key={getTabKey(tab)}>
                    <div
                      onClick={() => handleNavigation(tab.route)}
                      className="dashboard-card"
                    >
                      <div className="card-title">{tab.title}</div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

          {analyticsTabs.length > 0 && (
            <>
              <div className="subtitle">Analytics</div>
              <div className="dashboard-card-container">
                {analyticsTabs.map((tab) => (
                  <div key={getTabKey(tab)}>
                    <div
                      onClick={() => handleNavigation(tab.route)}
                      className="dashboard-card"
                    >
                      <div className="card-title">{tab.title}</div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

          {isDesktopDevice && contentTabs.length > 0 && (
            <>
              <div className="subtitle">Content Manangement System</div>
              <div className="dashboard-card-container">
                {contentTabs.map((tab) => (
                  <div key={getTabKey(tab)}>
                    <div
                      onClick={() => handleNavigation(tab.route)}
                      className="dashboard-card"
                    >
                      <div className="card-title">{tab.title}</div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Dashboard;
